<template>
<div class="wrapper">
  <div v-if="!loading">
      <div>
        <CButton class="col-1 mt-3 " variant="outline" color="info" @click="print()">Print</CButton>
        <!-- <CButton class="col-3 mt-3 " variant="outline" color="info">
          <download-excel
            :data="json_data"
            :fields="json_fields"
            :name= "filename"
          >
            Download Excel
          </download-excel>
        </CButton> -->
        <CButton class="col-3 mt-3 " variant="outline" color="info" @click="exportToExcel">
          Export to Excel
        </CButton>
        <!-- <pre>{{ json_fields }}</pre> -->
      </div>
      <br>
      <div class="table-responsive">
        <div class="panel-body" id="print">
          <h3>Ikid Report Attendance</h3>
          <h6>Period: {{ period}}</h6>
          <h6 v-if="class_name">Class Name: {{ class_name}}</h6>
          <h6 v-if="service_type">Service Type: {{ service_type}}</h6>
          <br>
          <table id="report-table" class="table" style="width:1000px; border: 1px solid black;">
            <thead>
              <tr>
                <th style="width: 10px;">#</th>
                <th style="width: 400px;">Kid Name</th>
                <th style="width: 400px;">Class Name</th>
                <th style="width: 400px;">Grade Name</th>
                <th v-for="(dt, index) in label_sundays" :key="index" style="width: 200px;">{{ dt }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dt, index) in rpt" :key="index">
                <td style="border: 1px solid black;">{{ index+1 }}</td>
                <td style="border: 1px solid black;">{{ dt.kid_name }}</td>
                <td style="border: 1px solid black;">{{ dt.class_name }}</td>
                <td style="border: 1px solid black;">{{ dt.grade_name }}</td>

                <td
                    style="border: 1px solid black;"
                    v-for="(sunday, index) in sundays"
                    :key="index"
                    :style="{
                        backgroundColor: sunday.includes('sv1') ? '#FFF8DE' : (sunday.includes('sv2') ? '#D0E8C5' : '')
                    }"
                >
                    {{ dt[sunday] ? dt[sunday] : '' }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" style="border: 1px solid black; font-weight: bold;">Total</td>
                <td
                  style="border: 1px solid black; font-weight: bold;"
                  v-for="(sunday, index) in sundays"
                  :key="'total-' + index"
                >
                  {{
                    sunday.includes('Total')
                      ? ''
                      : rpt.reduce((total, row) => total + (row[sunday] ? 1 : 0), 0)
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
  </div>
  <div v-else class="d-flex content-center min-vh-100">
      <b-spinner variant="primary" label="Spinning"><br></b-spinner>
  </div>


</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import report from '@/services/report';

import Vue from "vue";
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

export default {

    data(){
        return{
          rpt:'',
          period:'',
          class_name:'',
          loading: false,
          filename: "a.xls",
          json_fields: {
              "Kid Name": "kid_name",
              "Class Name": "class_name",
          },
          json_data: [],
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
          sundays: [],
          label_sundays: [],
        }
    },
    created(){
      this.loadData()
    },
    mounted() {

    },
    methods: {
      loadData(){
        var params = {
          // month: this.$route.query.month,
          // year: this.$route.query.year,
          start_date: this.$route.query.report_start_date,
          end_date: this.$route.query.report_end_date,
          service_type: this.$route.query.report_service_type,
          class_id: this.$route.query.report_class_id,
          grade_id: this.$route.query.report_grade_id
        }
        this.loading = true
        report.getIkidReportMonthAttendance(params)
        .then(res => {
            let getData = res.data
            // this.period = res.periodMonth + ' ' + res.periodYear
            this.period = res.start_date + ' to ' + res.end_date
            this.class_name = res.class_name
            this.service_type = res.service_type
            this.filename = "Ikid Report Attendance " + this.period
            if (this.class_name !== '') {
              this.filename = this.filename + " - Class " + this.class_name
            }
            if (this.service_type !== '') {
              this.filename = this.filename + " - " + this.service_type
            }
            this.sundays = res.sundays
            this.label_sundays = res.label_sundays
            this.rpt = getData
            this.json_data = getData
            this.loading = false

            // fill json_field with data from sunday for column
            this.sundays.forEach((sunday) => {
              this.$set(this.json_fields, sunday, sunday);
            });

            this.json_data = this.json_data.map(item => {
              const modifiedItem = { ...item };
              for (const key in modifiedItem) {
                if (modifiedItem[key] === false) {
                  modifiedItem[key] = '';
                } else if (modifiedItem[key] === true) {
                  modifiedItem[key] = 'O';
                }
              }
              return modifiedItem;
            });

        }).catch ((err) => {
          alert(err.response.data.message)
        })
      },
      print () {
        // Pass the element id here
        this.$htmlToPaper('print', null, () => {
          console.log('Printing completed or was cancelled!');
        });
      },
      handleDownloadExcel() {
        // Logic for generating and downloading the Excel file
        const data = this.json_data;
        const fields = this.json_fields;
        const name = this.filename;

        // Your logic for generating and downloading the Excel file here
        // ...

        // Example code for generating a simple CSV file
        const csvContent = "data:text/csv;charset=utf-8," +
          fields.map(field => field.label).join(",") +
          "\n" +
          data.map(item => fields.map(field => item[field.value]).join(",")).join("\n");

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", name + ".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      exportToExcel() {
        // Get the table
        const table = document.getElementById("report-table").outerHTML;

        // Prepare the data
        const blob = new Blob([`
          <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
          <head>
            <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Sheet1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
          </head>
          <body>${table}</body>
          </html>
        `], { type: "application/vnd.ms-excel" });

        // Create a download link
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = this.filename + ".xls";
        link.click();
      },
    }
}
</script>
<style>
.table-responsive {
  overflow-x: auto;
  white-space: nowrap;
}
</style>